
/* eslint-disable */
import CloudFun, { Condition, defineComponent, Operator, ref } from '@cloudfun/core'
import Grid, { GridOptions } from '@/cloudfun/components/Grid.vue'
import { VxeFormProps } from 'vxe-table'
import SelectBox, { SelectBoxOptions } from "@/cloudfun/components/SelectBox.vue";
import formatDate from 'xe-utils/toDateString'

export default defineComponent({
  components: {
    Grid,
    SelectBox,
  },
  setup () {
    const model = CloudFun.current?.model;
    const documentStatus = ref();
    const date = ref();
    const enums = model?.enums as any;
    const sdate = ref();
    const edate = ref();

    const grid = ref<any>({});
    var printColumns = [
      { field: 'Name' },
      { field: 'Description' }
    ]

    const gridOptions: GridOptions = {
      stripe: false,
      title: '會員權益購買統計管理',
      toolbarConfig: {
        custom: true,
        refresh: true
      },
      multiselect: false,
      canDelete: false,
      canUpdate: false,
      canCreate: false,
      canRead: false,
      printConfig: { sheetName: '會員權益購買統計管理清單', columns: printColumns, modes: ['current', 'selected', 'all'] },
      exportConfig: { filename: '會員權益購買統計管理清單', type: 'csv', types: ['html', 'csv'], mode: 'all', modes: ['current', 'selected', 'all'], columns: printColumns },
      columns: [
        { field: 'Account', title: '會員帳號', showHeaderOverflow: true, showOverflow: true },
        { field: 'Member', title: '會員姓名', showHeaderOverflow: true, showOverflow: true },
        { field: 'Organization', title: '團體名稱', showHeaderOverflow: true, showOverflow: true },       
        { field: 'JobTitle', title: '職稱', showHeaderOverflow: true, showOverflow: true },
        { field: 'Rights', title: '權益名稱', showHeaderOverflow: true, showOverflow: true },
        { field: 'StartDate', title: '開始日期', showHeaderOverflow: true, showOverflow: true, formatter: ({ cellValue }) => cellValue ? formatDate(new Date(cellValue), 'yyyy/MM/dd') : '' },
        { field: 'EndDate', title: '結束日期', showHeaderOverflow: true, showOverflow: true, formatter: ({ cellValue }) => cellValue ? formatDate(new Date(cellValue), 'yyyy/MM/dd') : '' },
      ],
      promises: {
        query: model ? (params: any) => {
          if (params?.sortings?.length === 0) {
            params.sortings.push({ column: 'CreatedTime', order: 1 });
          }
          if(sdate.value) {
            params.sdate = formatDate(sdate.value, 'yyyy-MM-dd')
          } else {
            params.sdate = null;
          }
          if(edate.value) {
            params.edate = formatDate(edate.value, 'yyyy-MM-dd')
          } else {
            params.edate = null;
          }
          // if(grid.keyword.value) {
          //   params.keyword = documentStatus.value
          // }
          console.log(params.date, params.keyword)
          return model.dispatch('report/queryMemberRightsStatistics', params)
        } : undefined,
        queryAll: model ? () => model.dispatch('report/queryMemberRightsStatistics') : undefined,
      },
      modalConfig: { width: "70%", showFooter: true },
      // treeConfig: { children: 'Children' }
    }

    const formOptions: VxeFormProps = {
      titleWidth: 120,
      titleAlign: 'right',
      items: [
        {
          field: 'Account',
          title: '會員帳號',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true }, attrs: { type: 'text' } }
        },
        {
          field: 'Organization',
          title: '團體名稱',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true }, attrs: { type: 'text' } }
        },
        {
          field: 'Member',
          title: '會員姓名',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true } }
        },
        {
          field: 'JobTitle',
          title: '職稱',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true } }
        },
        {
          field: 'Rights',
          title: '權益名稱',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true } }
        },
        {
          field: 'StartDate',
          title: '權益開始日期',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', readonly: true } }
        },
        {
          field: 'EndDate',
          title: '權益結束日期',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入數字', readonly: true } }
        },
      ],
      rules: {
      }
    }

    const s2ab = (s: any) => {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

    const exportExcel = async() => {
      const params = {} as any;
      if(sdate.value) {
        params.sdate = formatDate(sdate.value, 'yyyy-MM-dd')
      } else {
        params.sdate = null;
      }
      if(edate.value) {
        params.edate = formatDate(edate.value, 'yyyy-MM-dd')
      } else {
        params.edate = null;
      }
      try {
        var data = await model!.dispatch('report/queryMemberRightsStatistics', { keyword: grid.value.keyword, sdate: params.sdate, edate: params.edate, export: true });
        const file = new Blob([s2ab(atob(data))], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = "會員權益購買統計.xlsx";
        link.click();
      } catch (error: any) {
        CloudFun.send("error", {
          subject: "執行失敗",
          content: error,
        });
      }
    }

    return {
      grid,
      gridOptions,
      formOptions,
      model,
      documentStatus,
      sdate,
      edate,
      exportExcel,
    }
  },
  methods: {
    hideBatchDropDown () {
      cash('#batch-dropdown').dropdown('hide')
    }
  }
})
